import {
  faCirclePlay,
  faCube,
  faFilePdf,
  faImage,
  faLink,
  faPanorama,
  faStreetView,
  faVolume,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon, type FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

type ContentTypeIconProps = Omit<FontAwesomeIconProps, "icon">;

export const contentTypeIcons: Record<string, React.FC<ContentTypeIconProps>> = {
  Default: (props) => <FontAwesomeIcon data-testid="content-type-icon-default" icon={faVolume} {...props} />,
  "360 Photo": (props) => <FontAwesomeIcon data-testid="content-type-icon-360" icon={faPanorama} {...props} />,
  "3D Model": (props) => <FontAwesomeIcon data-testid="content-type-icon-3d" icon={faCube} {...props} />,
  "Virtual Tour": (props) => (
    <FontAwesomeIcon data-testid="content-type-icon-virtual-tour" icon={faStreetView} {...props} />
  ),
  Video: (props) => <FontAwesomeIcon data-testid="content-type-icon-video" icon={faCirclePlay} {...props} />,
  Photo: (props) => <FontAwesomeIcon data-testid="content-type-icon-photo" icon={faImage} {...props} />,
  PDF: (props) => <FontAwesomeIcon data-testid="content-type-icon-pdf" icon={faFilePdf} {...props} />,
  Link: (props) => <FontAwesomeIcon data-testid="content-type-icon-link" icon={faLink} {...props} />,
  Audio: (props) => <FontAwesomeIcon data-testid="content-type-icon-audio" icon={faVolume} {...props} />,
};
